// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiResultRequest {
    static getAttributeTypeMap() {
        return MedicalBiResultRequest.attributeTypeMap;
    }
}
MedicalBiResultRequest.discriminator = undefined;
MedicalBiResultRequest.additionalProperties = false;
MedicalBiResultRequest.attributeTypeMap = [
    {
        "name": "mock",
        "baseName": "mock",
        "type": "boolean"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiResultRequest.js.map